import Heading from './heading';
import Body from './body';
import Link from './link';

export { Heading, Body, Link };
